import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getLinkedClientAccounts, selectLinkedAccounts } from "./AccountLinkingBannerSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import {
  getClientPortalUserProfile,
  selectUserProfile,
} from "app/modules/account/components/cards/components/UserProfileSlice";

export function AccountLinkingBanner() {
  const [showBanner, setShowBanner] = useState(true);
  const linkedAccounts = useSelector(selectLinkedAccounts);
  const thunkDispatch = useThunkDispatch();

  const user = useSelector(selectUserProfile);

  useEffect(() => {
    thunkDispatch(getClientPortalUserProfile());
  }, [thunkDispatch]);

  useEffect(() => {
    if (user?.clientPortalUserID && user?.companyID) {
      thunkDispatch(
        getLinkedClientAccounts({
          clientPortalUserID: user?.clientPortalUserID,
          companyID: user?.companyID,
        })
      );
    }
  }, [thunkDispatch, user?.clientPortalUserID, user?.companyID]);

  return (
    <div>
      {linkedAccounts?.length === 0 && showBanner && (
        <div className={"alert alert-dismissible " + "bg-warning" + " d-flex align-items-center p-4 mt-3 p-sm-5 mb-4"}>
          <span className="fa fa-warning fa-xl text-dark me-4"></span>
          <div className="d-flex flex-column pe-10 text-dark">
            <h5 className="mb-1 text-dark">You haven't linked any of your accounts yet</h5>
            <span>
              Click here to
              <Link
                data-test-id="account-linking-banner__add-account-link"
                to="/addaccount"
                className="cpl-text-primary cpl-link"
                onClick={() => setShowBanner(false)}
              >
                <b> add an account</b>
              </Link>
            </span>
          </div>

          <button
            data-test-id="account-linking-banner__close-button"
            type="button"
            className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
            data-bs-dismiss="alert"
          >
            <span className="fa fa-times text-dark"></span>
          </button>
        </div>
      )}
    </div>
  );
}
